import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/lib/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => {
        return localStorage.getItem("dic_lang") || "en";
    });

    useEffect(() => {
        localStorage.setItem("dic_lang", lang);
    }, [lang]);

    const t = translations[lang];
    const toggle = () => setLang((l) => (l === "en" ? "ta" : "en"));

    return (
        <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLang() {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLang must be used within LanguageProvider");
    return ctx;
}
